// extracted by mini-css-extract-plugin
export default {"popover":"ColumnChooserPopover_popover__LRFGT"};